<template>
  <a @click="_newListener($event)" href="#" class="btn btn-secondary order-4"
     :class="def.isReadOnly === 'true'
               || def.isReadOnly === 'update'
               || readOnly
               || dataChanged ? 'readonly' : ''"
  >
    <span class="icon wb-plus"></span>
  </a>
</template>

<script>
import PDELinkGenerator from '../../model/wrapper/pde-link-params'
import ResourceGetter   from '../../model/resource/getter/resource-getter'
import Swal             from 'sweetalert2/dist/sweetalert2.js'

export default {

  props: {
    def:                   {
      type:    Object,
      default: function () {
        return null
      }
    },
    parentData:            {
      type:    Object,
      default: function () {
        return null
      }
    },
    formDataCheckFunction: {
      type:    Function,
      default: null
    },
    urlParentDataProp:     {
      type:    String,
      default: function () {
        return null
      }
    },
    readOnly:              {
      type:    Boolean,
      default: false
    },
    dataChanged:           {
      type:    Boolean,
      default: false
    }
  },

  computed: {
    urlParentData: {
      get: function () {
        return this.urlParentDataProp ? JSON.parse(this.urlParentDataProp) : null
      }
    }
  },

  created () {
    if (!this.def) {
      throw new Error('Definition must be set!')
    }
  },

  methods: {
    /**
     *
     * @private
     */
    _newListener (e) {
      e.preventDefault()

      if (this.def.isReadOnly === 'true'
        || this.def.isReadOnly === 'update'
        || this.readOnly
        || this.dataChanged
      ) {
        return
      }

      const success = (data) => {
        if (data) {
          this.parentData.data = data.data
        }

        if (this.parentData) {
          this.def.replaceWhereCondition(this.parentData.data.ID)
        }

        let ruleParams = {
          ruleType: 'NEWREC',
          ruleName: this.def.newRec,
          where:    this.def.whereCondition
        }

        // volani obchodniho pravidla NEWREC + zpracovani response
        ResourceGetter
          .get(this.def.viewName)
          .setDef(this.def)
          .callBusinessRule(ruleParams)
          .then((response) => {

            if (response.data.messages) {
              Swal.fire(response.data.messages, '')
            }

            // redirect to sub editor for createing new sub row
            PDELinkGenerator.defaults = response.data.values
            PDELinkGenerator.target   = PDELinkGenerator.targetNewName
            PDELinkGenerator.redir    = this.redir

            if (this.parentData) {
              let parent = {
                id:            this.$route.params.id,
                page:          this.$route.params.page,
                idEStructure:  this.$route.params.idStructure,
                label:         this.parentData.data.SEARCHTEXT,
                urlHash:       window.location.hash,
                parent:        JSON.stringify(this.urlParentData),
                triggerCalrec: true
              }

              const parentData = this.urlParentData ? this.urlParentData : []

              parentData.push(parent)

              PDELinkGenerator.parent    = JSON.stringify(parentData)
              PDELinkGenerator.parentDef = this.parentData.def
            }

            this.$router.push(PDELinkGenerator.getParams(this.def))
          })
          .catch((error) => {
            this.handleApiError(error)
          })
      }

      if (this.formDataCheckFunction) {
        this.formDataCheckFunction(success, null, true, true)
        return
      }

      success()
    }
  }
}
</script>

<style scoped>
.btn-secondary.readonly {
  opacity: 0.5;
}
</style>
